<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-6">
          <v-img :src="post.image" height="400px"></v-img>
          <v-card-title class="headline">{{ post.title }}</v-card-title>
          <v-card-subtitle>{{ post.category }}</v-card-subtitle>
          <v-card-text>{{ post.content }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Back Button to go to the blog list -->
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="goBack">Back to Blogs</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "BlogPost",
  data() {
    return {
      post: {
        id: null,
        title: "",
        content: "",
        image: "",
        category: "",
      },
    };
  },
  created() {
    // Fetch the blog post data based on the ID from the route
    const postId = this.$route.params.id;
    this.getPostDetails(postId);
  },
  methods: {
    getPostDetails(id) {
      // Simulated blog post data, in a real app you would fetch this from an API
      const blogPosts = [
        {
          id: 1,
          title: "10 Best Hiking Trails",
          content: "This is the full content of the 10 Best Hiking Trails.",
          image: "https://placeimg.com/800/400/nature",
          category: "Nature",
        },
        {
          id: 2,
          title: "How to Become a Digital Nomad",
          content: "This is the full content on How to Become a Digital Nomad.",
          image: "https://placeimg.com/800/400/tech",
          category: "Lifestyle",
        },
        {
          id: 3,
          title: "Understanding AI",
          content: "This is the full content about Understanding AI.",
          image: "https://placeimg.com/800/400/tech",
          category: "Technology",
        },
      ];

      // Find the blog post based on the passed ID
      const post = blogPosts.find((blog) => blog.id === parseInt(id));
      if (post) {
        this.post = post;
      }
    },
    goBack() {
      this.$router.push({ name: "home", query: { akey: 'blog' } });
    },

  },
};
</script>

<style scoped>
/* You can style the blog post page here */
</style>
